import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import FormField from "../FormField";
import { useTranslation } from "react-i18next";
import { Switch } from "@mui/material";

function UserInfo({
  formData,
  onChange,
  validateFormCallback,
  touched,
  serverErrors = {},
}) {
  const { values } = formData;
  const { t } = useTranslation();

  const [formFields, setFormFields] = useState({
    // store_type: values.store_type || "",
    firstname: values.firstname || "",
    lastname: values.lastname || "",
    phone: values.phone || "",
    password: values.password || "",
    password2: values.password2 || "",
    old_user: values.old_user || false,
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!formFields.firstname.trim()) {
      newErrors.firstname = `${t("Le prénom est requis")}`;
    }
    if (!formFields.lastname.trim()) {
      newErrors.lastname = `${t("Le nom de famille est requis")}`;
    }
    if (!formFields.phone.trim()) {
      newErrors.phone = `${t("Le numéro de téléphone est requis")}`;
    } else if (!/^\d{8}$/.test(formFields.phone.trim())) {
      newErrors.phone = `${t(
        "Le numéro de téléphone doit contenir 8 chiffres"
      )}`;
    }
    if (!formFields.password.trim()) {
      newErrors.password = `${t("Le mot de passe est requis")}`;
    }
    if (!formFields.password2.trim()) {
      newErrors.password2 = `${t("Veuillez confirmer le mot de passe")}`;
    } else if (formFields.password !== formFields.password2) {
      newErrors.password2 = `${t("Les mots de passe ne correspondent pas")}`;
    }

    setErrors(newErrors);
    validateFormCallback(Object.keys(newErrors).length === 0);
  };

  useEffect(() => {
    onChange(formFields);
    // eslint-disable-next-line
  }, [formFields]);

  useEffect(() => {
    validateForm();
    // eslint-disable-next-line
  }, [formFields, t]);

  const handleInputChange = (fieldName, value) => {
    if (
      ["firstname", "lastname"].includes(fieldName) &&
      /^\d+$/.test(value.trim())
    ) {
      return;
    }
    setFormFields((prevFields) => ({ ...prevFields, [fieldName]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: null }));
  };

  return (
    <SoftBox>
      <SoftBox lineHeight={0}>
        <SoftTypography variant="h5" fontWeight="bold">
          {t("Informations de client")}
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormField
              label={t("Prénom")}
              name="firstname"
              value={formFields.firstname}
              onChange={(e) => handleInputChange("firstname", e.target.value)}
              placeholder={t("Entrez votre prénom")}
              error={touched && errors.firstname}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              label={t("Nom de famille")}
              name="lastname"
              value={formFields.lastname}
              onChange={(e) => handleInputChange("lastname", e.target.value)}
              placeholder={t("Entrez votre nom de famille")}
              error={touched && errors.lastname}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type="number"
              label={t("Numéro de téléphone")}
              name="phone"
              value={formFields.phone}
              onChange={(e) => handleInputChange("phone", e.target.value)}
              placeholder={t("Entrez votre numéro de téléphone")}
              error={touched && (errors.phone || serverErrors.phone)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SoftBox display="flex" flexDirection="column" justifyContent="center" height="100%">
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  {t("Ancien Client")}
                </SoftTypography>
              </SoftBox>
              <SoftBox ml={0.5}>
                <Switch
                  checked={formFields.old_user}
                  onChange={(e) => handleInputChange("old_user", e.target.checked)}
                />
              </SoftBox>
            </SoftBox>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              label={t("Mot de passe")}
              name="password"
              type="password"
              value={formFields.password}
              onChange={(e) => handleInputChange("password", e.target.value)}
              placeholder={t("Entrez votre mot de passe")}
              error={touched && errors.password}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              label={t("Confirmer le mot de passe")}
              name="password2"
              type="password"
              value={formFields.password2}
              onChange={(e) => handleInputChange("password2", e.target.value)}
              placeholder={t("Confirmez votre mot de passe")}
              error={touched && errors.password2}
            />
          </Grid>
        </Grid>
      </SoftBox>
    </SoftBox>
  );
}

export default UserInfo;
